
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface UserFilterPanelProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const UserFilterPanel: React.FC<UserFilterPanelProps> = ({
  searchQuery,
  onSearchChange
}) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="text-lg">Team Overview</CardTitle>
        <CardDescription>
          Manage your team members and their access levels
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center space-x-2 mb-4">
          <Search className="h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search by name, email, role or status..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="max-w-sm"
          />
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('')}
          >
            All
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('admin')}
          >
            Admins
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('finance')}
          >
            Finance
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('warehouse')}
          >
            Warehouse
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('seller')}
          >
            Sellers
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('active')}
          >
            Active
          </Badge>
          <Badge 
            variant="outline" 
            className="cursor-pointer hover:bg-secondary" 
            onClick={() => onSearchChange('inactive')}
          >
            Inactive
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
};
